var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('pi-sys-content',{staticClass:"pi-pages-operation-data",attrs:{"white":false}},[(_vm.isEchart)?_c('pi-revenue-data'):_vm._e(),_c('pi-settlement-data'),(_vm.isEchart)?_c('pi-order-data'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }